var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisterSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.9997 88.1666C69.2877 88.1666 88.1663 69.2879 88.1663 45.9999C88.1663 22.7119 69.2877 3.83325 45.9997 3.83325C22.7117 3.83325 3.83301 22.7119 3.83301 45.9999C3.83301 69.2879 22.7117 88.1666 45.9997 88.1666Z",
    stroke: "#158C6F",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.1669 34.5L40.6336 61.3333L26.4502 46",
    stroke: "#158C6F",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterSuccessIcon);
export default __webpack_public_path__ + "static/media/RegisterSuccessIcon.afb2da44070cb0b85a31f33e3382be28.svg";
export { ForwardRef as ReactComponent };